import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const FAQ = () => {
  const { t } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(null);
  const faqs = t.faq.items;

  return (
    <section id="faq" className="py-24 px-6 bg-black relative">
      <div className="pexadia-watermark"></div>
      <div className="max-w-4xl mx-auto relative z-20">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1.5 mb-6 border border-[#d4af37]/30 rounded-full bg-[#d4af37]/5">
            <span className="text-[10px] font-black tracking-[0.2em] gold-gradient uppercase">
              {t.faq.badge}
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl font-serif mb-6 italic">
            {t.faq.title1} <span className="gold-gradient">{t.faq.title2}</span>
          </h2>
          <p className="text-gray-400 text-xl font-light leading-relaxed">
            {t.faq.description}
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="glass-card rounded-[2rem] overflow-hidden transition-all border-white/5">
              <button
                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                className="w-full p-8 text-left flex justify-between items-center hover:bg-white/5 transition-colors"
              >
                <span className="font-bold text-xl tracking-tight">{faq.question}</span>
                <i className={`fas fa-chevron-down text-[#d4af37] transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-8 overflow-hidden transition-all duration-300 ${activeIndex === index ? 'max-h-96 pb-8 opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="text-gray-400 leading-relaxed font-light">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

